import { render, staticRenderFns } from "./category-menu.vue?vue&type=template&id=088eaf1a&scoped=true"
import script from "./category-menu.vue?vue&type=script&lang=js"
export * from "./category-menu.vue?vue&type=script&lang=js"
import style0 from "./category-menu.vue?vue&type=style&index=0&id=088eaf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088eaf1a",
  null
  
)

export default component.exports